<template>
  <v-card class="pa-4">
    <div class="text-center">
      <h2>Adicionar analisador</h2>
    </div>

    <v-form ref="form" class="mt-4">
      <label class="text-caption ml-1">Nome:</label>
      <v-text-field
        v-model="analyser.name"
        class="primary-input"
        outlined
        dense
        placeholder="Insira um nome para o analisador"
        hide-details="auto"
        :rules="[(v) => !!v || 'Nome obrigatório']"
      ></v-text-field>

      <v-row class="ma-0">
        <v-col> </v-col>
      </v-row>
    </v-form>

    <div class="d-flex justify-end">
      <v-btn
        @click="save"
        :loading="loading"
        color="secondary"
        depressed
        class="ma-0"
      >
        Salvar
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
export default {
  name: 'ManageAnalyser',

  props: {
    analyserProp: Object,
  },

  created() {
    if (this.analyserProp.id) {
      this.analyser = { ...this.analyserProp }
      this.isEditing = true
    }

    const institution = JSON.parse(localStorage.getItem('institution'))
    this.analyser.institutionId = institution.id
  },

  data() {
    return {
      isEditing: false,
      apiService: new ApiService(),
      analyser: { name: '' },
      loading: false,
    }
  },

  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.loading = true

        if (this.isEditing) {
          this.apiService
            .put('electricalSafetyAnalyser', this.analyser)
            .then(() => {
              this.$toast.success('Analisador cadastrado com sucesso!')
              this.$emit('close')
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          this.apiService
            .post('electricalSafetyAnalyser', this.analyser)
            .then(() => {
              this.$toast.success('Analisador atualizado com sucesso!')
              this.$emit('close')
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        }
      }
    },
  },
}
</script>

<style scoped></style>
